import { painPoints } from '@/mocks/red-packet';
import SectionHeading from '@/components/base/SectionHeading';
import Reveal from '@/components/base/Reveal';

export default function PainPoints() {
  return (
    <section className="w-full px-4 md:px-6 py-16 md:py-24 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <SectionHeading
          eyebrow="痛点洞察"
          title="传统补贴与促销，常常卡在「最后一公里」"
          subtitle="从发放到核销，补贴链条的每一环都可能成为转化的损耗点。"
        />

        <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {painPoints.map((item, idx) => (
            <Reveal key={item.title} delay={idx * 80}>
              <div className="group h-full p-6 rounded-lg bg-background-100 border border-background-200 transition-all duration-300 hover:-translate-y-1 hover:border-secondary-300">
                <div className="w-12 h-12 flex items-center justify-center rounded-md bg-background-50 border border-background-200 text-foreground-600 transition-colors group-hover:bg-secondary-100 group-hover:text-secondary-700">
                  <i className={`${item.icon} text-xl`}></i>
                </div>
                <h3 className="mt-5 font-heading font-bold text-lg text-foreground-950">
                  {item.title}
                </h3>
                <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}